import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import logo from "../../assets/images/6ixlogo.png";
import { UserIcon } from "../../icons";
import AIChatAction from "./AIChatAction";

const AIChatMessages = props => {
  const {
    messageList,
    userData,
    messagesRef,
    handleScroll,
    sendQuery,
    sending,
    handleLogin,
  } = props;

  const messageQ = msg => {
    return (
      <div className="events-page-aichat-content-messages-box-question events-page-aichat-content-messages-box">
        <div className="events-page-aichat-content-messages-box-logo events-page-aichat-content-messages-box-question-logo">
          {userData?.profileImage ? (
            <img src={userData.profileImage} alt="" />
          ) : (
            <UserIcon />
          )}
        </div>
        <div className="events-page-aichat-content-messages-box-text events-page-aichat-content-messages-box-question-text">
          {msg}
        </div>
      </div>
    );
  };
  const messageA = (message, lastIndex) => {
    return (
      <div className="events-page-aichat-content-messages-box-answer events-page-aichat-content-messages-box">
        <div className="events-page-aichat-content-messages-box-logo">
          <img src={logo} alt="logo" />
        </div>
        <div className="events-page-aichat-content-messages-box-text">
          <ReactMarkdown
            components={{
              a: ({ node, ...props }) => (
                <a
                  {...props}
                  target="_blank"
                  className="text-link text-primary"
                  rel="noopener noreferrer"
                >
                  {props.children}
                </a>
              ),
            }}
            remarkPlugins={[remarkGfm]}
          >
            {message?.response}
          </ReactMarkdown>
        </div>
        {lastIndex && sending ? (
          <></>
        ) : (
          <AIChatAction
            message={message}
            userData={userData}
            sendQuery={sendQuery}
            handleLogin={handleLogin}
          />
        )}
      </div>
    );
  };
  return (
    <div
      className="events-page-aichat-content-messages"
      ref={messagesRef}
      onScroll={handleScroll}
    >
      {messageList?.map((message, index) => (
        <div key={index} className="events-page-aichat-content-messages-row">
          {messageQ(message?.query)}
          {messageA(message, index === messageList?.length - 1)}
        </div>
      ))}
    </div>
  );
};

export default AIChatMessages;
